// import LazyImage from '@basicComponents/image';
import React from 'react';
// import {View} from 'react-native';
import theme from '@style';
import {useInnerStyle} from '../proxy.hooks';
import {ruleBookImage} from '../proxy.variable';
// import Text from '@basicComponents/text';
import i18n from '@/i18n';
import styles from './index.module.scss';
import {Image} from 'antd-mobile';

const ProxyRulesTitle = () => {
  const {
    // size: {bookSize},
    // rulesStyle,
  } = useInnerStyle();
  return (
    <div
      // style={[
      //   theme.flex.col,
      //   theme.flex.start,
      //   theme.fill.fillW,
      //   theme.position.rel,
      //   // theme.margin.top2l,
      //   theme.padding.leftl,
      //   // theme.margin.bottom2l,
      // ]}
      className={styles.rule_title_container}>
      <div className="flex flex-row gap-2 w-full items-center">
        <div
          style={{
            ...theme.flex.col,
            ...theme.flex.start,
          }}
          className="flex flex-col gap-2 flex-start">
          <span className={styles.rule_title}>
            {i18n.t('proxy.rules.title')}
          </span>
          <span className={styles.rule_title_tip}>
            {i18n.t('proxy.rules.subtitle')}
          </span>
        </div>
        <Image src={ruleBookImage} className={styles.rule_book} />
        {/* <div>
          <LazyImage
          occupancy="#0000"
          width={bookSize}
          height={bookSize}
          imageUrl={ruleBookImage}
        />
        </div> */}
      </div>
    </div>
  );
};

export default ProxyRulesTitle;
